export const SCOPES_SUPPORTED = ["mcp:tools", "mcp:resources"];

export const ENDPOINT_MCP = "mcp";
export const ENDPOINT_HEALTH = "health";
export const ENDPOINT_OAUTH_PROTECTED_RESOURCE = ".well-known/oauth-protected-resource";
export const ENDPOINT_OAUTH_CLIENT_METADATA = ".well-known/oauth-client-metadata";
export const ENDPOINT_TEST_AUTHORIZE_CLIENT = "inspector-client.json";
